import { offsetFeatureCollectionPixelPerfect } from "./offsetFeatureCollection"

const MIN_ZOOM = 14
const MIN_ZOOM_OFFSET = 7
const MAX_ZOOM = 18
const MAX_ZOOM_OFFSET = 30

export const getLateralizedOffset = function (zoom) {
    if (zoom <= MIN_ZOOM) {
        return MIN_ZOOM_OFFSET
    }
    if (zoom <= MAX_ZOOM) {
        return MIN_ZOOM_OFFSET + (zoom - MIN_ZOOM) / (MAX_ZOOM - MIN_ZOOM) * (MAX_ZOOM_OFFSET - MIN_ZOOM_OFFSET)
    }

    return MAX_ZOOM_OFFSET
}

export const computeLateralizedFeatures = function (featureCollection, map) {
    if (!featureCollection) {
        return
    }
    return offsetFeatureCollectionPixelPerfect(
        map,
        featureCollection,
        () => getLateralizedOffset(map.getZoom()),
    )
}